<template>
  <div v-if="showview" class="rem">

    <div class="dialog">
      <div class="dialog-content">
        <div class="dialog-content-tit">删除理由</div>

        <div class="dialog-content-reason">
          <div v-if="datas" class="dialog-radio">
            <div v-for="(item,idx) in datas" :key="idx" class="item">
              <el-radio v-model="radio" :label="item.dictKey" @change="reasonchange">{{ item.dictValue }}</el-radio>
            </div>
          </div>

        </div>
        <div v-if="showInput" class="dialog-content-input">
          <textarea :maxlength="maxlen" rows="10" placeholder="请输入删除理由，等待管理员删除" @input="inputChange" />
          <div class="flex-row-align-center">
            <p class="font-size-12 ">{{ reqdel.length }}/</p>
            <p class="font-size-12 ">{{ maxlen }}</p>
          </div>
        </div>

        <div class="dialog-btns">
            <span class="btns btn-cancel" @click="dismiss">取消</span>
            <span class="btns btn-ok" @click="confirm">确定</span>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    maxlen: {
      type: Number,
      default: 20
    },
    datas: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      radio: 1,
      showview: false,
      reqdel: {
        length: 0,
        desc: '',
        id: null
      },
      showInput: false,
    }
  },
  methods: {
    show() {
      this.showview = true
      this.radio = 1
      this.reqdel.desc = this.datas[0].dictValue
      this.reqdel.id = this.datas[0].dictKey
    },
    dismiss() {
      this.showview = false
    },
    confirm() {
      if (this.reqdel.desc.length) {
        this.showview = false
        this.$emit('apply', this.reqdel)
      } else {
        console.error('需要提示用户输入申请删除理由')
      }
    },
    inputChange(e) {
      this.reqdel.length = e.target.value.length
      this.reqdel.desc = e.target.value
    },
    reasonchange(e) {
      if (e === 8) {
        this.showInput = true
      } else {
        this.showInput = false
        this.reqdel.desc = this.datas[e - 1].dictValue
        this.reqdel.id = this.datas[e - 1].dictKey
      }
      console.log(this.reqdel)
    }
  }
}
</script>
<style src="@/styles/wap.scss" lang="scss" scoped>
</style>
<style lang="css" scoped>
  .app{ 
    position: relative;
    }
  .dialog {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 996;
    background-color: rgba(0, 0, 0, 0.5);
  }

  .dialog-content {
    position: fixed;
    width: 8.8rem;
    padding:.6rem!important; 
    background:#fff;
    border-radius: .12rem;
    left:50%; 
    top:5rem;
    margin-left:-5rem!important
  }
  .dialog-content-tit{ 
    height: 1.4rem; 
    line-height: 1rem; 
    font-size: .48rem;
    text-align: center;
  }
  .dialog-radio .item{
    text-align: center;
    display: inline-block;
    width:1.99rem; 
    height:.8rem;
    line-height: .8rem;
    border:1px solid #e7ebf1;
    border-radius: .12rem;
    margin:0 .2rem .3rem 0;
    font-size: .3rem;
    color:#264480;
    overflow: hidden;
  }
  
   .dialog-radio .item:nth-child(4n){
     margin-right: 0;
   }
  ::v-deep .el-radio{ 
    display: block;
    width:inherit;
    height: inherit;
    line-height: inherit;
  }
  ::v-deep .is-checked{
    background:#264480;
  }
  ::v-deep .is-checked .el-radio__label{
    color:#fff !important
  }
  ::v-deep .el-radio__input{
    font-size: 0 !important;
    width:0 !important;
    height: 0 !important;
    opacity: 0 !important;
  }
  ::v-deep .el-radio__label{ 
    padding-left:0 !important;
  }

  .dialog-content-input {
    height: 2rem;
    border: 1px solid rgba(189, 193, 208,0.5);
    background: #F3F4F9;
    padding: .3rem;
    border-radius: .12rem;
  }

  .dialog-content-input textarea {
    border: none;
    width: 100%;
    height: 2rem;
    background:none;
    resize: none;
    font-size: .36rem;
  }

  .dialog-btns{
    height: .8rem;
    margin-top:.4rem;
    padding:0 .8rem
  }
  .dialog-btns .btns{
    display: block;
    height: .8rem;
    width:3rem;
    text-align: center; 
    line-height: .8rem;
    font-size: .36rem;
    color:#264480;
    background:#F3F4F9;
    border-radius: .12rem;
    float: left;
  }
  .dialog-btns .btn-ok{
    color:#fff;
    background:#264480;
    float:right;
  }

  .dialog-content-input div {
    justify-content: flex-end;
  }

  .dialog-content-input textarea:focus{
    outline: none;
  }

  textarea::-webkit-input-placeholder {
    /* WebKit browsers */
    color: #7B84A1;
    opacity: 0.5;
  }
  textarea:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #7B84A1;
    opacity: 0.5;
  }
  textarea::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #7B84A1;
    opacity: 0.5;
  }

  .dialog-content-btns {
    justify-content: flex-end;
    margin-top: 28px;
  }

</style>
